import type { TextElement } from '../../shared/document';

export function heightForCurveChange(element: TextElement, nextCurve: number): number {
  const lineCount = Math.max(1, element.text.split('\n').length);
  const naturalTextHeight = element.fontSize * element.lineHeight * lineCount;
  const baseHeight = Math.max(
    180,
    naturalTextHeight,
    // Documents created before tight curve bounds used twice the curve
    // amplitude as spare vertical space. Remove that legacy excess when the
    // curve is edited, then reserve only the actual arc height.
    element.transform.height - Math.abs(element.curve) * 2,
  );
  return baseHeight + Math.abs(nextCurve);
}
